const base = '/dash'

// Catalgoue Links 
export const DEMO_CATALGUE_PATH = `/catalogue`;
export const DEMO_CATALGUE_DETAILS_PATH = `/catalogue/`;
export const DEMO_CATALGUE_DETAILS_PLAYBOOK_PATH = `/catalogue/playbook/`;

export const YADS_INGESTION =`/narrative-catalogue`;

// Core Pages Links
export const HOME_PATH = `/home`;
export const RESET_PATH = `/reset`;
export const BOOKING_PATH = `/booking`;
export const PROFILE_PATH = `/profile`;
export const UPDATE_EMAIL_PATH = `/update-email`;
export const EMAIL_VERIFICATION_SENT_PATH = `/email-verification-sent`;
export const EMAIL_UPDATED_PATH = `/email-updated`;
export const EMAIL_VERIFICATION_INVALID_PATH = `/email-verification-invalid`;
export const EMAIL_CHANGE_VERIFY_PATH = `/email-change/verify`;
export const ADMIN_PATH = `/admin`;
export const ADMIN_USERS_PATH = `/admin/users`;
export const ADMIN_TENANTS_PATH = `/admin/tenants`;
export const ADMIN_ALERTS_PATH = `/admin/alerts`;
export const SALES_WALKTHROUGH_PATH = `/onboarding`;
export const ANALAYTICS_PATH = `/profile/analytics`;
export const MANAGER_CONSOLE_PATH = `/profile/manager-console`;
export const LEADERSHIP_CONSOLE_PATH = `/profile/leadership-console`;
export const SE_ACTIVITIES_IMPACT_ANALYSIS_PATH = `/profile/se-activities-impact-analysis`;
export const IDEA_COMMUNITY_PATH = `/idea-community`;
export const DEMO_SUPPORT_PATH = `/demo-support`;

// Content Store
export const CONTENT_STORE_PATH = `/store`;
export const CONTENT_STORE_FILEFORMAT_PATH = `/store/`;
export const CONTENT_STORE_FILES_PATH = `/store/files/`;


// FAQ
export const FAQ_PATH = `/faq`;
export const FAQ_QUESTION_PATH =`/faq/`;

export const SEARCH_PATH =`/search`


// What's new 
export const WHAT_NEW_PATH = `/what-new/`;
export const WHAT =`/what-new`


// Learning Hub
export const LEARNING_HUB_PATH =`/learning`;
export const LEARNING_HUB_TRACKS_PATH =`/learning/tracks/`;
export const LEARNING_HUB_MICROCERTS_PATH =`/learning/microcert/`;
export const LEARNING_HUB_MANDATORY_TRAINING_PATH =`/learning/dsom/`;

// Sales
export const SALES_DASHBOARD_PATH = '/sales/';

// Partner Portal
export const PARTNER_PORTAL_PATH = '/partner-portal';
export const PARTNER_PORTAL_SUBMIT_PATH = '/partner-portal/submit';
export const PARTNER_PORTAL_MY_PROJECTS_PATH = '/partner-portal/my-projects';
export const PARTNER_PORTAL_PAE_QUEUE_PATH = '/partner-portal/pae/project-queue';
export const PARTNER_PORTAL_LEADERSHIP_PATH = '/partner-portal/leadership/pipeline';
